export const VDCover = require('./VD_Cover.jpg');
export const Close = require('./Close.png');



// WEBPACK FOOTER //
// ./src/images/index.js